module.exports = angular;


//////////////////
// WEBPACK FOOTER
// external "angular"
// module id = 7
// module chunks = 6